// extracted by mini-css-extract-plugin
module.exports = {"subtitle":"styles_subtitle__e_ADK","actionLabel":"styles_actionLabel__WNSet","button":"styles_button__mjDNw"};